import { Language } from '@ha/intl';

import { ContentfulSupportedLangs } from '../constants';

const isContentfulSupported = (lang: Language) =>
  ContentfulSupportedLangs.includes(lang);
export { isContentfulSupported };
